module.exports = "/images/coloredBasket.gif";